var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menu" }, [
    _c(
      "div",
      {
        staticClass: "menu-button toggle",
        on: {
          click: function($event) {
            _vm.menu_visible = !_vm.menu_visible
          }
        }
      },
      [
        _c("div", { staticClass: "line" }),
        _c("div", { staticClass: "line" }),
        _c("div", { staticClass: "line" })
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.menu_visible,
            expression: "menu_visible"
          }
        ],
        staticClass: "content"
      },
      [
        _c("div", { staticClass: "section" }, [
          _vm._v("Sextants:"),
          _c("span", { staticClass: "good" }, [
            _vm._v(_vm._s(_vm.good_sextants))
          ]),
          _c("span", [_vm._v("/")]),
          _c("span", { staticClass: "bad" }, [_vm._v(_vm._s(_vm.bad_sextants))])
        ]),
        _c("div", { staticClass: "section" }, [
          _vm._v("Multiselect:"),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.multiselect,
                expression: "multiselect"
              }
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.multiselect)
                ? _vm._i(_vm.multiselect, null) > -1
                : _vm.multiselect
            },
            on: {
              change: function($event) {
                var $$a = _vm.multiselect,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.multiselect = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.multiselect = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.multiselect = $$c
                }
              }
            }
          })
        ]),
        _c("div", { staticClass: "section" }, [
          _c("button", { on: { click: _vm.clear_sextants } }, [
            _vm._v("Clear Sextants")
          ])
        ]),
        _c("div", { staticClass: "section" }, [
          _c("button", { on: { click: _vm.reset_atlas } }, [
            _vm._v("Reset Atlas")
          ])
        ]),
        _c("div", { staticClass: "section" }, [
          _c("button", { on: { click: _vm.help } }, [_vm._v("Help!")]),
          _c("button", { on: { click: _vm.commands } }, [_vm._v("Commands")])
        ]),
        _vm._m(0)
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section support-wrapper" }, [
      _c("p", [_vm._v("If you find the site useful, please:")]),
      _c(
        "a",
        {
          staticClass: "bmc-button",
          attrs: {
            target: "_blank",
            href: "https://www.buymeacoffee.com/duiker101"
          }
        },
        [_vm._v("Support Me")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2393e969", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2393e969","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SextantsMenu.vue
// module id = 48
// module chunks = 0